/**
 * workflow-core
 *
 * Copyright (c) Ballerine
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
import { z } from 'zod';

var ActiveMonitoringSchema = z.object({
  type: z.literal('aml'),
  vendor: z["enum"](['veriff', 'test', 'dow-jones']),
  monitoredUntil: z.string().datetime(),
  sessionId: z.string()
});
var EndUserActiveMonitoringsSchema = z.array(ActiveMonitoringSchema);
var SourceSchema = z.object({
  type: z.string().nullable().optional(),
  sourceName: z.string().nullable().optional(),
  sourceUrl: z.string().url().nullable().optional(),
  date: z.string().nullable().optional()
});
var AmlHitSchema = z.object({
  vendor: z["enum"](['veriff', 'test', 'dow-jones']),
  matchedName: z.string().nullable(),
  countries: z.array(z.string()),
  matchTypes: z.array(z.string()),
  warnings: z.array(SourceSchema),
  sanctions: z.array(SourceSchema),
  fitnessProbity: z.array(SourceSchema),
  pep: z.array(SourceSchema),
  adverseMedia: z.array(SourceSchema),
  other: z.array(SourceSchema).optional()
});
var EndUserAmlHitsSchema = z.array(AmlHitSchema);

export { EndUserActiveMonitoringsSchema, EndUserAmlHitsSchema };
//# sourceMappingURL=end-user.schema.js.map
